import { getAllTrackingParams } from './trackingParams';
import _ from 'lodash';

/**
 * Formats info about a client into an object structure that Nestio accepts.
 * (See http://developers.nestio.com/api/v1/clients.html)
 *
 * @param {Object} clientInfo Info, in the format produced by the ClientInfoFields component.
 * @param {String} mode Either "api" or "widget". This is because the Nestio schedule a tour
 *                      widget actually formats the clients it POSTs slightly differently than
 *                      the API expects.
 */
export function clientInfoToNestioFormat(clientInfo, mode = 'api', leadSource) {
  const NESTIO_API_LAYOUT_CODES = {
    studio: 10,
    '1-bedroom': 20,
    '1-bedroom-home-office': 20,
    '2-bedroom': 30,
  };
  // const NESTIO_API_LAYOUT_CODES = {
  //   studio: "studio",
  //   "1-bedroom": "1br",
  //   "1-bedroom-home-office": "1br",
  //   "2-bedroom": "2br",
  // };
  const NESTIO_WIDGET_LAYOUT_CODES = {
    studio: 'studio',
    '1-bedroom': '1br',
    '1-bedroom-home-office': '1br',
    '2-bedroom': '2br',
  };

  const layouts = Object.keys(clientInfo.floorplans).filter(
    (k) => clientInfo.floorplans[k]
  );
  let nestioLayouts = layouts.map(
    (k) =>
      mode === 'api'
        ? NESTIO_WIDGET_LAYOUT_CODES[k]
        : NESTIO_API_LAYOUT_CODES[k]
    // mode === "api" ? NESTIO_API_LAYOUT_CODES[k] : NESTIO_WIDGET_LAYOUT_CODES[k]
  );
  const data = {
    client: {
      people: [
        {
          first_name: clientInfo.firstName,
          last_name: clientInfo.lastName,
          email: clientInfo.emailAddress,
          phone_1: clientInfo.phoneNumber,
        },
      ],
      group: 1,
      layout: nestioLayouts,
      // layout: nestioLayouts.filter(
      //   (item, idx) => nestioLayouts.indexOf(item) === idx
      // ), //remove dupes
      campaign_info: renderNotes(
        clientInfo.isBroker,
        clientInfo.comments,
        clientInfo.url_params,
        layouts,
        clientInfo.terraced
      ),
      notes: clientInfo.comments,
      lead_source: leadSource || '300 Ashland Waitlist',
      source_type: 'organic',
      sms_opted_in: 'marketing-enabled',
    },
  };

  // Note: the Number() call in isNaN is redundant; there for explicitness.
  if (clientInfo.maxBudget !== null && !isNaN(Number(clientInfo.maxBudget))) {
    data.client.price_ceiling = Number(clientInfo.maxBudget);
  }

  if (clientInfo.moveInDate !== null) {
    data.client.move_in_date = clientInfo.moveInDate.format('YYYY-MM-DD');
  }

  return data;
}

export function clientInfoToFormspree(unformatted_data, mode = 'api') {
  const NESTIO_API_LAYOUT_CODES = {
    studio: 10,
    '1-bedroom': 20,
    '1-bedroom-home-office': 20,
    '2-bedroom': 30,
  };
  // const NESTIO_API_LAYOUT_CODES = {
  //   studio: "studio",
  //   "1-bedroom": "1br",
  //   "1-bedroom-home-office": "1br",
  //   "2-bedroom": "2br",
  // };
  const NESTIO_WIDGET_LAYOUT_CODES = {
    studio: 'studio',
    '1-bedroom': '1br',
    '1-bedroom-home-office': '1br',
    '2-bedroom': '2br',
  };

  const layouts = Object.keys(unformatted_data.floorplans).filter(
    (k) => unformatted_data.floorplans[k]
  );
  let nestioLayouts = layouts.map(
    (k) =>
      mode === 'api'
        ? NESTIO_WIDGET_LAYOUT_CODES[k]
        : NESTIO_API_LAYOUT_CODES[k]
    // mode === "api" ? NESTIO_API_LAYOUT_CODES[k] : NESTIO_WIDGET_LAYOUT_CODES[k]
  );

  const data = {
    full_name: unformatted_data.firstName + ' ' + unformatted_data.lastName,
    email: unformatted_data.emailAddress,
    phone: unformatted_data.phoneNumber,
    layout: nestioLayouts.toString(),
    _message: renderNotes(
      unformatted_data.isBroker,
      unformatted_data.comments,
      unformatted_data.url_params,
      layouts,
      unformatted_data.terraced
    ),
    comments: unformatted_data.comments,
    first_name: unformatted_data.firstName,
    floorplans: unformatted_data.floorplans,
    is_broker: unformatted_data.isBroker,
    last_name: unformatted_data.lastName,
    max_budget: unformatted_data.maxBudget,
    move_in_date: unformatted_data.moveInDate,
    private: unformatted_data.private,
    terrace_unit: unformatted_data.terraced,
    unitNumber: unformatted_data.unitNumber,
    url_params: unformatted_data.url_params,
    lead_source: unformatted_data.lead_source,
  };

  if (
    unformatted_data.maxBudget !== null &&
    !isNaN(Number(unformatted_data.maxBudget))
  ) {
    data.price_ceiling = Number(unformatted_data.maxBudget);
  }

  if (unformatted_data.moveInDate !== null) {
    data.move_in_date = unformatted_data.moveInDate.format('YYYY-MM-DD');
  }

  return data;
}

function renderNotes(isBroker, clientComments, url_params, layouts, terraced) {
  const trackingParams = getAllTrackingParams('N/A');
  const _note = clientComments || "I'm interested in 300 Ashland";
  const notes = [
    ...(clientComments ? [`User comments: ${_note}`] : []),
    `Broker: ${isBroker ? 'yes' : 'no'}`,
    `Terrace Selected: ${terraced}`,
    'Analytics:',
    `- Page landed on: ${trackingParams.pathname}`,
    '- Query parameters present on users landing URL:',
    `- Layouts: ${layouts}${terraced && ',terraced'}`,
    `${url_params}`,
  ];
  return notes.join('\n');
}



// WEBPACK FOOTER //
// ./client/services/clients.js